// Export der Anrufliste ("Download Call Log" in ViewCallLogs und ViewCallLogsAdmin).
// Tabulator-getrennt und als UTF-16 mit BOM gespeichert (in Excel "Unicode-Text"): So erkennt Excel die Spalten auch
// beim Doppelklick, unabhängig vom Listentrennzeichen der Spracheinstellung, und zeigt Umlaute richtig. Die Endung bleibt
// .csv, damit sich die Datei weiter mit Excel öffnet. Erwartet formatDate() in der Komponente.

// Gesprächsprotokoll als lesbarer Text: eine Zeile je Eintrag mit dem Sprecher wie im Vorschau-Fenster
// (Caller, Bot, Staff beim Live-Dolmetscher, Action). response kommt als JSON-Text oder, nachdem die Vorschau
// geöffnet wurde, als Array
function callLogMessageText(response) {
  let entries = response;

  if (typeof response === 'string') {
    try {
      entries = JSON.parse(response);
    } catch (error) {
      return response; // Kein JSON: unverändert übernehmen
    }
  }

  if (!Array.isArray(entries)) {
    return typeof response === 'string' ? response : '';
  }

  return entries.map(entry => {
    const text = String(entry?.text ?? '');

    if (entry?.action === 'UserRecognizedText') {
      return `Caller: ${text}`;
    }
    // Live-Dolmetscher: Sätze des Mitarbeiters kommen von AI-Phone als BotResponseText mit "Staff:" davor
    if (entry?.action === 'BotResponseText' && text.startsWith('Staff:')) {
      return `Staff: ${text.slice(6).trim()}`;
    }
    if (entry?.action === 'BotResponseText') {
      return `Bot: ${text}`;
    }
    return `Action: ${text}`;
  }).join('\n');
}

// Eine Zelle: immer in Anführungszeichen, Anführungszeichen darin verdoppelt. So dürfen Tabulatoren und Zeilenumbrüche
// im Text stehen. Excel führt Zellen, die mit = + - @ beginnen, als Formel aus (Formel-Injektion, z. B. über eine
// gefälschte Rufnummer): solche Werte bekommen ein ' davor. Reine Rufnummern wie "+49 541 123456" bleiben unverändert
function exportCell(value) {
  let text = value === null || value === undefined ? '' : String(value);

  if (/^[=+\-@\t\r]/.test(text) && !/^\+?[\d\s()/-]+$/.test(text)) {
    text = `'${text}`;
  }

  return `"${text.replace(/"/g, '""')}"`;
}

// Text als UTF-16LE mit BOM (FF FE); ein Blob aus einem String wäre immer UTF-8
function utf16leWithBom(text) {
  const withBom = '﻿' + text;
  const view = new DataView(new ArrayBuffer(withBom.length * 2));

  for (let i = 0; i < withBom.length; i++) {
    view.setUint16(i * 2, withBom.charCodeAt(i), true);
  }

  return view.buffer;
}

export default {
  methods: {
    downloadCallLogCsv(calls, filename) {
      const headers = ['PhoneBot', 'Category', 'Priority', 'Phone Number', 'Status', 'Message', 'Date/Time'];
      const rows = calls.map(call => [
        call.bezeichnung,
        call.selected_category,
        call.priority,
        call.caller_number,
        call.status,
        callLogMessageText(call.response),
        this.formatDate(call.created_at),
      ]);

      const content = [headers, ...rows].map(row => row.map(exportCell).join('\t')).join('\r\n');

      const blob = new Blob([utf16leWithBom(content)], { type: 'text/csv;charset=utf-16le;' });
      const url = URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', filename);
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      setTimeout(() => URL.revokeObjectURL(url), 0);
    },
  },
};
